import { render, staticRenderFns } from "./KartaKlienti.vue?vue&type=template&id=7ccccd68&scoped=true&"
import script from "./KartaKlienti.vue?vue&type=script&lang=js&"
export * from "./KartaKlienti.vue?vue&type=script&lang=js&"
import style0 from "./KartaKlienti.vue?vue&type=style&index=0&id=7ccccd68&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ccccd68",
  null
  
)

export default component.exports